import { WorkerMissionStatus } from '@/types/mission';

export const WORKER_MISSION_STATUS_ORDER: WorkerMissionStatus[] = [
	WorkerMissionStatus.CONFIRMED,
	WorkerMissionStatus.ACCEPTED,
	WorkerMissionStatus.PROPOSED,
	WorkerMissionStatus.REPROPOSED,
	WorkerMissionStatus.NOT_CONFIRMED,
	WorkerMissionStatus.DECLINED,
	WorkerMissionStatus.REJECTED_BY_AGENCY,
	WorkerMissionStatus.ABORTED,
];

export const MISSION_STATUS_COLOR_TO_CSS_VARIABLE: Record<string, string> = {
	yellow: 'var(--yellow-base, #FAB305)',
	green: 'var(--green-base, #00A355)',
	blue: 'var(--blue-base, #2051F8)',
	red: 'var(--red-base, #E51940)',
	grey: 'var(--icon-sub-500, #636778)',
	black: 'var(--neutral-900, #00061A)',
};

export const getWorkerMissionStatusOrderPosition = (
	status: WorkerMissionStatus
): number => {
	const statusPosition = WORKER_MISSION_STATUS_ORDER.indexOf(status);
	return statusPosition === -1
		? WORKER_MISSION_STATUS_ORDER.length
		: statusPosition;
};
